//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { IReferenceType, IOpChangeState, IJsonSerializable } from '../util/interfaces'
import { Enums } from '../common/enums'
import { DataProvider } from '../../helpers/data-provider'

import { OpDescr } from './op-descr'

export class OpReferenceType implements IReferenceType, IOpChangeState, IJsonSerializable {
    public idReferenceType: number
    public name: string
    public idDescr: number
    public descr: OpDescr

    constructor(opObj: any = null) {
        this.fromJSON(opObj)
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end
    //IReferenceType implementation
    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdReferenceType
    }
    public getReferenceKey(): number {
        return this.idReferenceType
    }
    public getReferenceValue(): any {
        return this
    }
    //IReferenceType implementation end

    
    public fromJSON(opObj: any, compressed: boolean = false): void {

        if (opObj) {

            if (compressed || (opObj && opObj.__IC && opObj.__IC == 1)) {

                this.idReferenceType = opObj.I
                this.name = opObj.N
                this.idDescr = opObj.ID
                this.descr = opObj.D ? new OpDescr(opObj.D) : null
                this.opState = opObj.O

            } else {

                this.idReferenceType = opObj.ID_REFERENCE_TYPE
                this.name = opObj.NAME
                this.idDescr = opObj.ID_DESCR
                this.descr = opObj._Descr ? new OpDescr(opObj._Descr) : null
                this.opState = opObj.OpState

            }
        }
    }

    public toJSON(compressed: boolean = false): any {

        if (compressed) {
            return {
                I: this.idReferenceType,
                N: this.name,
                ID: this.idDescr,
                D: this.descr != null ? this.descr.toJSON() : null,
                O: this.opState,

                __IC: 1
            }
        } else {
            return {
                ID_REFERENCE_TYPE: this.idReferenceType,
                NAME: this.name,
                ID_DESCR: this.idDescr,
                _Descr: this.descr != null ? this.descr.toJSON() : null,
                OpState: this.opState
            }
        }
    }

    public toString() {
        if (this.descr)
            return this.descr.description
        else
            return this.name
    }

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpReferenceType[]): JQueryPromise<OpReferenceType[]> {
        var defered = $.Deferred<OpReferenceType[]>()

        defered.resolve(list)

        return defered.promise()
    }

    public static restore(restoredOpObj: OpReferenceType) {
        if (restoredOpObj) {
            var opObj = new OpReferenceType()
            opObj.idReferenceType = restoredOpObj.idReferenceType
            opObj.name = restoredOpObj.name
            opObj.idDescr = restoredOpObj.idDescr
            opObj.descr = OpDescr.restore(restoredOpObj.descr)
            opObj.opState = restoredOpObj.opState
            return opObj
        }
        return null
    }
}